var navigation = []

const requireContext = require.context('.', false, /.*\.(js)$/)
requireContext.keys().forEach(file => {
  const navigationFile = requireContext(file)

  if ('default' in navigationFile) {
    navigation = navigation.concat(navigationFile.default)
  }

})

export default navigation
